import React, { Component } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import {
  Modal,
  Input,
  Button,
  SelectPicker,
  Form,
  FormGroup,
  ControlLabel
} from 'rsuite';

export default class ReportTemplateFormModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    templates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    fileType: PropTypes.string.isRequired,
    file: PropTypes.shape({}).isRequired,
    isSaving: PropTypes.bool.isRequired,
    onInit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSubmitted: PropTypes.func,
    handleClose: PropTypes.func
  };

  static defaultProps = {
    handleClose: () => {},
    onSubmitted: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      selectedTemplate: null
    };
  }

  componentDidMount() {
    const { templates, onInit } = this.props;
    onInit(templates);
  }

  componentDidUpdate(prevProps) {
    const { isSaving, onSubmitted } = this.props;
    if (prevProps.isSaving && !isSaving) {
      onSubmitted();
    }
  }

  get templatesAsOptions() {
    const { templates } = this.props;
    return fp.map(
      ({ id, fileName }) => ({
        label: fileName,
        value: id
      }),
      templates
    );
  }

  handleSubmit = () => {
    const { fileName, selectedTemplate } = this.state;
    const { onSubmit, fileType, file } = this.props;
    const template = { ...selectedTemplate, fileName, fileType, file };

    onSubmit(template);
  };

  handleSelectTemplate = id => {
    const { templates } = this.props;
    const selectedTemplate = fp.find({ id }, templates);
    const fileName = fp.getOr('', 'fileName', selectedTemplate);
    this.setState({ selectedTemplate, fileName });
  };

  handleNameChange = fileName => {
    this.setState({ fileName });
  };

  handleShow = () => {
    this.setState({ fileName: '', selectedTemplate: null });
  };

  render() {
    const { fileName, selectedTemplate } = this.state;
    const { show, handleClose, isSaving } = this.props;
    return (
      <Modal
        overflow
        size="xs"
        show={show}
        onHide={handleClose}
        onShow={this.handleShow}
      >
        <Modal.Header>
          <Modal.Title>Save/Update Preset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGroup>
              <ControlLabel>
                Select &#34;New Preset&#34; or &#34;Existing Preset&#34;
              </ControlLabel>
              <SelectPicker
                placeholder="New Preset"
                data={this.templatesAsOptions}
                onChange={this.handleSelectTemplate}
                style={{ width: '100%' }}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                {selectedTemplate ? 'Update As *' : 'Save As New *'}
              </ControlLabel>
              <Input
                style={{ paddingLeft: '10px' }}
                value={fileName}
                onChange={this.handleNameChange}
                placeholder="Preset name"
              />
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.handleSubmit}
            appearance="primary"
            disabled={!fileName || isSaving}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </Button>
          <Button onClick={handleClose}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
